<div class="wizard-authentication p-r w-100">
    <div class="flex-col flex gap-16 w-100">
        @if (nvrErrorBanner) {
        <div class="nvr-error-banner">
            <span class="ui-icon-info"></span>
            <div class="nvr-error-text">{{ nvrErrorBanner }}</div>
        </div>
        }
        <!-- Manual discovery results (before credentials) -->
        @if (showManualDiscoveryTable) {
        <div class="manual-discovery-block">
            <div class="progress-section" *ngIf="manualDiscoveryProgress !== 100">
                <div class="flex-row center-center w-100">
                    <div class="p-r w-100 progress-wrapper">
                        <div class="progress-wrapper-inner">
                            <mat-progress-bar class="w-100" mode="determinate" [value]="manualDiscoveryProgress"></mat-progress-bar>
                        </div>
                        <div class="progress-background"></div>
                    </div>
                    <div class="progress-percent">{{ manualDiscoveryProgress }}%</div>
                </div>
            </div>

            <app-camera-table
                [dataSourceInput]="manualDiscoveryRows"
                [multiSelect]="false"
                [disableRowClick]="true"
                [manualDiscoveryMode]="true"
                [displayedColumns]="manualDiscoveryDisplayedColumns">
            </app-camera-table>
        </div>
        }

        <!-- Credentials Configuration Section -->
        @if (showCredentials) {
        <div class="credentials-section">
            @for (credential of credentialsArr; track $index; let credentialIndex = $index) {
            <div class="credential-row">
                <div class="credential-fields">
                    <!-- Username -->
                    <div class="field-group">
                        <label>{{ 'CAMERA_ACTIVATE_DIALOG.USERNAME'|translate }}</label>
                        <input class="ui-input" type="text" [(ngModel)]="credential.username" placeholder="" />
                    </div>

                    <!-- Password -->
                    <div class="field-group password-field">
                        <div class="flex-row space-between-center">
                          <label>{{ 'CAMERA_ACTIVATE_DIALOG.PASSWORD'|translate }}</label>
                          <span [class.ui-icon-hide]="!credential.showPassword" [class.ui-icon-show]="credential.showPassword" (click)="credential.showPassword = !credential?.showPassword"></span>
                        </div>
                        <div class="password-input-wrapper">
                            <input class="ui-input" [type]="credential.showPassword ? 'text' : 'password'" [(ngModel)]="credential.password" placeholder="" />
                        </div>
                    </div>

                    @if (isOnvifFlow) {
                    <!-- Divider -->
                    <div class="flex-col">
                        <div>&nbsp;</div>
                        <div class="horizontal-divider">&nbsp;</div>
                    </div>

                    <!-- Substream -->
                    <div class="field-group substream-field">
                        <label>{{ 'CAMERA_ACTIVATE_DIALOG.SUB_STREAM'|translate }}</label>
                        <mat-checkbox [(ngModel)]="credential.subStream"></mat-checkbox>
                    </div>
                    } @else {
                    <!-- Divider -->
                    <div class="flex-col">
                        <div>&nbsp;</div>
                        <div class="horizontal-divider">&nbsp;</div>
                    </div>

                    <!-- Port -->
                    <div class="field-group port-field">
                        <label>{{ 'CAMERA_ACTIVATE_DIALOG.RTSP_PORT'|translate }}</label>
                        <input class="ui-input" type="number" [(ngModel)]="credential.port" placeholder="554" />
                    </div>

                    <!-- Protocol -->
                    <div class="field-group protocol-field">
                        <label>{{ 'ADD_CAMERA_WIZARD.AUTH.PROTOCOL'|translate }}</label>
                        <mat-select class="ui-selector" [(ngModel)]="credential.protocol">
                            @for (option of protocolOptions; track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                            }
                        </mat-select>
                    </div>
                    }

                    @if (manualDiscoveryEnabled && manualDeviceType === 'nvr') {
                    <!-- NVR Vendor -->
                    <div class="field-group flex-col flex">
                        <label>{{ 'ADD_CAMERA_WIZARD.AUTH.NVR_BRAND'|translate }}</label>
                        <mat-select class="ui-selector" [(ngModel)]="credential.nvrVendor"
                            (ngModelChange)="onNvrBrandChange(credential)">
                            @for (v of nvrVendorOptions; track v.value) {
                            <mat-option [value]="v.value">{{ v.label }}</mat-option>
                            }
                        </mat-select>
                        @if (credential.nvrVendor === 'genetec' && genetecDefaultsHint) {
                        <div class="genetec-defaults-hint">{{ genetecDefaultsHint }}</div>
                        }
                    </div>

                    <div class="field-group channels-field">
                        <label>{{ 'ADD_CAMERA_WIZARD.AUTH.CHANNELS'|translate }}</label>
                        <mat-select class="ui-selector" [(ngModel)]="credential.channelCount"
                            [disabled]="credential.nvrVendor === 'genetec'">
                            @for (c of nvrChannelCountOptions; track c) {
                            <mat-option [value]="c">{{ c }}</mat-option>
                            }
                        </mat-select>
                    </div>

                    <!-- Divider -->
                    <div class="flex-col">
                        <div>&nbsp;</div>
                        <div class="horizontal-divider">&nbsp;</div>
                    </div>

                    <!-- Substream -->
                    <div class="field-group substream-field">
                        <label>{{ 'CAMERA_ACTIVATE_DIALOG.SUB_STREAM'|translate }}</label>
                        <mat-checkbox [(ngModel)]="credential.subStream"></mat-checkbox>
                    </div>
                    }

                    <!-- RTSP Paths -->
                  @if (!isOnvifFlow && !(manualDiscoveryEnabled && manualDeviceType === 'nvr')) {
                    <div class="flex-col start-center flex">
                        @for (url of credential.urls; track $index; let urlIndex = $index) {
                        <div class="flex-row gap-8 start-start w-100 flex">
                            <div class="field-group rtsp-path flex">
                                <label *ngIf="urlIndex === 0">{{ 'CAMERA_ACTIVATE_DIALOG.RTSP_PATH'|translate }}</label>
                                <label *ngIf="urlIndex > 0" class="placeholder-label">&nbsp;</label>
                                <input class="ui-input" type="text" [(ngModel)]="url.mainUrl" [placeholder]="'ADD_CAMERA_WIZARD.AUTH.PATH_PLACEHOLDER'|translate" />
                            </div>

                            <!-- Divider -->
                            <div class="flex-col">
                                <div [class.placeholder-label]="urlIndex > 0">&nbsp;</div>
                                <div class="horizontal-divider">&nbsp;</div>
                            </div>

                            <div class="field-group substream-path flex">
                                <div class="label-with-info">
                                    <label *ngIf="urlIndex === 0">{{ 'ADD_CAMERA_WIZARD.AUTH.SUBSTREAM_RTSP_PATH'|translate }}</label>
                                    <label *ngIf="urlIndex > 0" class="placeholder-label">&nbsp;</label>
                                    <span *ngIf="urlIndex === 0" class="info-icon ui-icon-info-outline"></span>
                                </div>
                                <input class="ui-input" type="text" [(ngModel)]="url.subUrl" [placeholder]="'ADD_CAMERA_WIZARD.AUTH.PATH_PLACEHOLDER'|translate" />
                            </div>

                            <div class="url-actions">
                                <label [class.placeholder-label]="urlIndex > 0">&nbsp;</label>
                                <div class="action-buttons">
                                    @if (urlIndex === credential.urls.length - 1) {
                                        <span class="ui-icon-plus ui-icon-button no-border" (click)="addUrlRow(credentialIndex)"></span>
                                    } @else {
                                    <div class="icon-btn no-action">
                                    </div>
                                    }
                                    @if (credential.urls.length > 1) {
                                        <span class="ui-icon-delete ui-icon-button no-border" (click)="removeUrlRow(credentialIndex, urlIndex)"></span>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                        }
                    </div>

                @if (credentialsArr.length > 1) {
                    <span class="ui-icon-delete ui-icon-button no-border" (click)="removeCredentialRow(credentialIndex)"></span>
                }
            </div>
            }

            <!-- Action Buttons -->
            <div class="action-row">
                <ui-button type="default" (click)="addCredentialRow()">
                  <div class="flex-row start-center gap-8">
                    <span class="ui-icon-plus"></span>
                    <div>{{ 'ADD_CAMERA_WIZARD.AUTH.ADD_CREDENTIALS'|translate }}</div>
                  </div>
                </ui-button>
                <ui-button type="secondary" (click)="onConnect()" [disabled]="isConnecting">
                    {{ 'ADD_CAMERA_WIZARD.AUTH.CONNECT'|translate }}
                </ui-button>
            </div>
        </div>
        } @else {
        <!-- Collapsed credentials toggle -->
        <div class="credentials-collapsed">
            <button type="button" class="show-credentials-btn" (click)="toggleCredentials()">
                <span class="ui-icon-link"></span>
                {{ 'ADD_CAMERA_WIZARD.AUTH.SHOW_CREDENTIALS'|translate }}
            </button>
        </div>
        }

        <!-- Progress Bar (after connecting) -->
        @if (isConnecting || isConnected) {
        <div class="progress-section">
            <div class="flex-row center-center w-100">
                @if (isConnecting) {
                <div class="p-r w-100 progress-wrapper">
                    <div class="progress-wrapper-inner">
                        <mat-progress-bar class="w-100" mode="determinate" [value]="progress"></mat-progress-bar>
                    </div>
                    <div class="progress-background"></div>
                </div>
                <div class="progress-percent">{{ progress }}%</div>
                } @else if (isConnected) {
                {{ 'ADD_CAMERA_WIZARD.AUTH.SELECT_CAMERAS_TO_ADD'|translate }}
                }
            </div>
        </div>

        <!-- Camera List Table -->
        <div class="camera-list">
            <table class="camera-table ui-table">
                <thead>
                    <tr>
                        <th class="checkbox-col">
                            <mat-checkbox [checked]="areAllSuccessfulSelected"
                                [indeterminate]="selectedCount > 0 && !areAllSuccessfulSelected"
                                (change)="toggleAllCameras()"></mat-checkbox>
                        </th>
                        <th class="cameras-col">{{ (manualDiscoveryEnabled && manualDeviceType === 'nvr') ? ('ADD_CAMERA_WIZARD.AUTH.TABLE.CAMERAS'|translate) : ('COMMON.CAMERA'|translate) }}</th>
                        <th class="substream-col">{{ 'CAMERA_ACTIVATE_DIALOG.SUB_STREAM'|translate }}</th>
                        @if (manualDiscoveryEnabled && manualDeviceType === 'nvr') {
                        <th class="channel-col">{{ 'CAMERA_TABLE.CHANNEL'|translate }}</th>
                        } @else {
                        <th class="ip-col">{{ 'CAMERA_ACTIVATE_DIALOG.IP_ADDRESS'|translate }}</th>
                        <th class="brand-col">{{ 'CAMERA_TABLE.BRAND'|translate }}</th>
                        <th class="actions-col">{{ 'ADD_CAMERA_WIZARD.AUTH.TABLE.ACTIONS'|translate }}</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (state of cameraStatesArray; track state.camera.id) {
                    <tr [class.error]="state.status === 'error'" [class.success]="state.status === 'success'">
                        <td class="checkbox-col">
                            <span [matTooltip]="'ADD_CAMERA_WIZARD.AUTH.NO_SLOTS_LEFT' | translate"
                                [matTooltipDisabled]="!isCameraSelectionDisabledBySlots(state.camera.id)">
                                <mat-checkbox [checked]="isCameraSelected(state.camera.id)"
                                    [disabled]="isCameraSelectionDisabledBySlots(state.camera.id)"
                                    (change)="toggleCameraSelection(state.camera.id)"></mat-checkbox>
                            </span>
                        </td>
                        <td class="cameras-col">
                            <div class="camera-info">
                                <div class="camera-thumbnail">
                                    @if (state.status === 'loading' || state.status === 'pending') {
                                    <div class="thumbnail-placeholder loading">
                                      <ui-preloader [color]="loaderColor.blue" [diameter]="32"></ui-preloader>
                                    </div>
                                    } @else if (state.status === 'success' &&
                                    getSnapshotSrc(state, 'main')) {
                                    <img [appAuthSrc]="getSnapshotSrc(state, 'main')!"
                                        [appAuthSrcFallback]="getSnapshotFallbackSrc(state, 'main')"
                                        (authError)="onSnapshotError(state, 'main')"
                                        (authLoaded)="onSnapshotLoad(state, 'main')"
                                        [attr.alt]="'ADD_CAMERA_WIZARD.COMMON.CAMERA_SNAPSHOT_ALT'|translate" />
                                    } @else {
                                    <div class="thumbnail-placeholder error">
                                        <span class="ui-icon-camera-off"></span>
                                    </div>
                                    }
                                </div>
                                <div class="camera-name-section">
                                    @if (state.status === 'success') {
                                    <input class="ui-input camera-name-input" type="text"
                                        [(ngModel)]="state.camera.name" [placeholder]="'ADD_CAMERA_WIZARD.AUTH.CAMERA_NAME_PLACEHOLDER'|translate" />
                                    } @else {
                                    <span class="camera-name">{{ state.camera.name }}</span>
                                    }
                                    @if (state.status === 'error' && state.errorMessage) {
                                    <div class="error-message">
                                        <span class="ui-icon-info error-icon"></span>
                                        <span class="error-text" uiTruncateText [matTooltip]="state.errorMessage">{{
                                            state.errorMessage }}</span>
                                    </div>
                                    }
                                </div>
                            </div>
                        </td>
                        <td class="substream-col">
                            @if (state.connectionDetails?.cameraDocument?.substreamEnabled) {
                            <span class="substream-enabled">
                                <span class="ui-icon-checkmark"></span>
                            </span>
                            }
                        </td>
                        @if (manualDiscoveryEnabled && manualDeviceType === 'nvr') {
                        <td class="channel-col">{{ getChannel(state) ?? '-' }}</td>
                        } @else {
                        <td class="ip-col">{{ state.camera.ipAddress }}</td>
                        <td class="brand-col">{{ state.camera.cameraBrand || '-' }}</td>
                        <td class="actions-col">
                            @if (state.status === 'error') {
                            @if (getErrorCode(state) === 401) {
                            <a class="action-link" (click)="onAddCredentials()">{{ 'ADD_CAMERA_WIZARD.AUTH.ADD_CREDENTIALS'|translate }}</a>
                            } @else if (getErrorCode(state) === 404) {
                            <a class="action-link" (click)="onAddCredentials()">{{ 'ADD_CAMERA_WIZARD.AUTH.ADD_RTSP_PATH'|translate }}</a>
                            }
                            }
                        </td>
                        }
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        }
    </div>
</div>